import PropTypes from 'prop-types';
export const propTypes = {
  color: PropTypes.string
};
export const defaultProps = {
  color: 'white'
};